import { render, staticRenderFns } from "./MiniStat.vue?vue&type=template&id=9fe5d9e4&"
import script from "./MiniStat.vue?vue&type=script&lang=js&"
export * from "./MiniStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports